import {useState} from "react";
import {Text1, View} from "../../../../styles/business-components";
import * as S from './styles'
import Slider from "./Slider";
import Card, {CardVariant} from "./Card";

export const Content13 = () => {
    const [activeIndex, setActive] = useState(1);

    return (
        <S.Container id={"rates"}>
            <View>
                <S.Title>Лучшие цены за максимальную безопасность</S.Title>
                <Text1>
                    TeleGuard для бизнес-клиентов предлагает справедливое и непревзойденное соотношение цены
                    и качества. Мы с удовольствием подберем индивидуальный пакет лицензий и место размещения.
                </Text1>
                <Slider activeIndex={activeIndex} setActive={setActive}>
                    <Slider.Item>
                        <Card variant={CardVariant.BASE}>
                            <Card.Title>BASIC</Card.Title>
                            <Card.Content>
                                <Card.Desc>Для небольшлого числа пользователейи низких  функциональных требований</Card.Desc>
                                <Card.Item>
                                    <Card.Value>20</Card.Value>
                                    <Card.Text>участников видеоконференции</Card.Text>
                                </Card.Item>
                                <Card.Item>
                                    <Card.Value>250 Gb</Card.Value>
                                    <Card.Text>для хранения данных</Card.Text>
                                </Card.Item>
                                <Card.Item>
                                    <Card.Value>30 Days</Card.Value>
                                    <Card.Text>срок хранения на сервере</Card.Text>
                                </Card.Item>
                                <Card.Item>
                                    <Card.Value>24 h</Card.Value>
                                    <Card.Text>отклик поддержки</Card.Text>
                                </Card.Item>
                            </Card.Content>
                            <Card.Footer>
                                <Card.Button>CHF <S.CrossedText>7.90</S.CrossedText> 7.10</Card.Button>
                            </Card.Footer>
                        </Card>
                    </Slider.Item>
                    <Slider.Item>
                        <Card variant={CardVariant.PRO}>
                            <Card.Title>PRO</Card.Title>
                            <Card.Content>
                                <Card.Desc>Для небольшлого числа пользователейи низких  функциональных требований</Card.Desc>
                                <Card.Item>
                                    <Card.Value>50</Card.Value>
                                    <Card.Text>участников видеоконференции</Card.Text>
                                </Card.Item>
                                <Card.Item>
                                    <Card.Value>500 Gb</Card.Value>
                                    <Card.Text>для хранения данных</Card.Text>
                                </Card.Item>
                                <Card.Item>
                                    <Card.Value>∞</Card.Value>
                                    <Card.Text>срок хранения на сервере</Card.Text>
                                </Card.Item>
                                <Card.Item>
                                    <Card.Value>12 h</Card.Value>
                                    <Card.Text>отклик поддержки</Card.Text>
                                </Card.Item>
                            </Card.Content>
                            <Card.Footer>
                                <Card.Button>CHF <S.CrossedText>15.90</S.CrossedText> 14.30</Card.Button>
                            </Card.Footer>
                        </Card>
                    </Slider.Item>
                    <Slider.Item>
                        <Card variant={CardVariant.ENTERPRISE}>
                            <Card.Title>ENTERPRISE</Card.Title>
                            <Card.Content>
                                <Card.Desc>Для небольшлого числа пользователейи низких  функциональных требований</Card.Desc>
                                <Card.Item>
                                    <Card.Value>{'>'}100</Card.Value>
                                    <Card.Text>участников видеоконференции</Card.Text>
                                </Card.Item>
                                <Card.Item>
                                    <Card.Value>1 Tb</Card.Value>
                                    <Card.Text>для хранения данных</Card.Text>
                                </Card.Item>
                                <Card.Item>
                                    <Card.Value>∞</Card.Value>
                                    <Card.Text>срок хранения на сервере</Card.Text>
                                </Card.Item>
                                <Card.Item>
                                    <Card.Value>6 h</Card.Value>
                                    <Card.Text>отклик поддержки</Card.Text>
                                </Card.Item>
                            </Card.Content>
                            <Card.Footer>
                                <Card.Button>CHF <S.CrossedText>23.90</S.CrossedText> 21.50</Card.Button>
                            </Card.Footer>
                        </Card>
                    </Slider.Item>
                </Slider>
            </View>
        </S.Container>
    )
}